import { isNil } from "lodash";
import { CalendarMode, Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";

import { getOriginalResource } from "../../../helpers";
import { useBookingRowsContext } from "../../context/booking_rows_context";
import { useBookingsOverviewContext } from "../../context/bookings_overview_context";
import { useUtilizationDataProvider } from "../../workforce_metrics";

type UseUtilization = {
  row: Row;
};
type UseUtilizationReturn = {
  shouldDisplayUtilization: boolean;
  utilizationValue: number | undefined;
};

export const useUtilization = ({ row }: UseUtilization): UseUtilizationReturn => {
  const { calendarMode, showUtilizationMetrics } = useBookingsOverviewContext();
  const { warningsByProfile } = useBookingRowsContext();
  const { getUtilizationValue } = useUtilizationDataProvider();
  const { type } = row;

  const profileId = type === RowType.Profile ? getOriginalResource(row, calendarMode)?.id : null;
  const utilizationValue =
    warningsByProfile && !isNil(profileId) ? getUtilizationValue(warningsByProfile[profileId]) : undefined;
  const shouldDisplayUtilization =
    type === RowType.Profile &&
    calendarMode === CalendarMode.Workforce &&
    showUtilizationMetrics &&
    !isNil(utilizationValue);

  return { shouldDisplayUtilization, utilizationValue };
};
